import * as React from 'react';
import {Table,	Toolbar,	Field,	Button,	PlusFilledIcon,	TrashcanIcon,	PencilIcon,	Loader} from 'react-unity';
import { RulesFormProps } from './porRule/OnPremAbstractObjectsForm';
import Paginator from '../../common/tables/Paginator';
import ObjectModalOnPrem from './porRule/ObjectModalOnPrem';
import { ObjColumn, ObjectColumnsLayout } from './ObjectColumnsLayout';
import POROperationBadge from '../../../components/PortOpeningRequests/components/POROperationBadge';
import PORTypeBadge from '../../../components/PortOpeningRequests/components/PORTypeBadge';
import TrashcanModal from '../components/TrashcanModal';
import { RuleOperation } from '../../../models/enums/POR/RuleOperation';
import './OnPremObjectsTable.css';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import Select, { StylesConfig } from "react-select";
import ImplementedRulesModal from './ImplementedRulesModal';
import BulkUploadModal from './porRule/BulkUploadModal';
import OnPremPortOpeningObject from '../../../models/entities/OnPremPortOpeningObject';
import ObjectLookupModal from './ObjectLookupModal';

interface ObjectsTableProps {
	rules: OnPremPortOpeningObject[];
	readonly?: boolean;
	onChange: (rules: OnPremPortOpeningObject[]) => any;
	implementedObjects?: OnPremPortOpeningObject[];
	selectedFromExisting?: string[];
	setSelectedFromExisting?: (rule: string[]) => any;
	loadingImplementedObjects?: boolean;
	failedImplementedObjects?: boolean;
	fromDetails?: boolean;
	currentWorkflowState?: number;
}

interface ObjectsTableState {
	columns: ObjColumn[];
	ruleModalVisible: boolean;
	editingRule?: OnPremPortOpeningObject;
	bulkUploadModalVisible: boolean;
	pageRows: OnPremPortOpeningObject[];
	implementedRuleModalVisible: boolean;
	optionValueSelected: string,
	showTrashcanModal: boolean;
	objectLookupModalVisible: boolean;
}

export class OnPremObjectTable extends React.Component<ObjectsTableProps, ObjectsTableState> {

	constructor(props: ObjectsTableProps | Readonly<ObjectsTableProps>) {
		super(props);
		this.state = {
			columns: [],
			ruleModalVisible: false,
			bulkUploadModalVisible: false,
			pageRows: [],
			implementedRuleModalVisible: false,
			showTrashcanModal: false,
			optionValueSelected: "",
			objectLookupModalVisible: false,
		};
	}

	componentDidMount() {
		this.setColumns();
	}
	
	/*componentDidUpdate(prevProps: ObjectsTableProps) {
	 	this.setColumns();
	}*/
	
	setColumns() {
		this.setState({
			columns: ObjectColumnsLayout
		});
	}

	getRulesModalProps(): RulesFormProps {
		let editingRule = null;
		if (this.state.editingRule != null) {
			editingRule = { ...this.state.editingRule };
			editingRule.name = editingRule.name
		}
		return {
			visible: this.state.ruleModalVisible,
			onConfirm: this.handleRuleChange,
			onClose: () => this.setState({ editingRule: null, ruleModalVisible: false }),
			editingRule: editingRule,
		};
	}

	handleRuleChange = (rule: OnPremPortOpeningObject) => {
		let { rules } = this.props;
		if (this.state.editingRule) {
			const index = rules.indexOf(this.state.editingRule);
			rules = [...rules];
			rules[index] = rule;
		} else {
			rules = [...rules, rule];
		}
		this.props.onChange(rules);
		this.setState({ ruleModalVisible: false, editingRule: null });
	};

	handleDeleteAll = () => {
		this.props.onChange([]);
		this.resetTrashcanModal();
	};

	handleDeleteOrRemoveRule = (ruleToRemove: OnPremPortOpeningObject) => {
		/* if (ruleToRemove.operation.name==='Add')
			this.handleRemoveRule
		else
			this.setState({ showTrashcanModal: true, editingRule: ruleToRemove }) */
		this.setState({ showTrashcanModal: true, editingRule: ruleToRemove })
	};

	handleRemoveRule = () => {
		const rules = this.props.rules.filter(rule => rule !== this.state.editingRule);
		this.props.setSelectedFromExisting(this.props.selectedFromExisting.filter(ruleName => ruleName !== this.state.editingRule.name));
		this.props.onChange(rules);
		this.resetTrashcanModal();
	};

	handleDeleteRule = () => {
		let editingRule = { ...this.state.editingRule };
		editingRule.name = editingRule.name;
		editingRule.operation = RuleOperation.Remove;
		this.handleRuleChange(editingRule);
		this.resetTrashcanModal();
	};


	resetTrashcanModal = () => {
		this.setState({
			editingRule: null,
			showTrashcanModal: false
		})
	}

	closeTrashcanModal = this.resetTrashcanModal;

	handleBulkUpload = (rules: OnPremPortOpeningObject[]) => {
		this.setState({
			bulkUploadModalVisible: false,
			optionValueSelected: '',
		});
		this.props.onChange([...this.props.rules, ...rules]);
	};

	handlePageChange = (page: OnPremPortOpeningObject[]) => {
		this.setState({
			pageRows: page
		});
	};

	handleImplementedRulesOnSuccess = (impRules: OnPremPortOpeningObject[]) => {
		this.setState({
			implementedRuleModalVisible: false,
			optionValueSelected: '',
		});
		this.props.setSelectedFromExisting([...this.props.selectedFromExisting, ...impRules.map(rule => rule.name)])
		this.props.onChange([...this.props.rules, ...impRules]);
	};

	getOperationName(rule: OnPremPortOpeningObject) {
		if (this.props.fromDetails && this.props.currentWorkflowState !== WorkflowState.Review.value && this.props.currentWorkflowState !== WorkflowState.Draft.value) {
			return this.state.columns.find(column => column.header === 'operation').cell(rule)
		}
		const operationColumn = this.state.columns.find(column => column.header === 'operation')
		return operationColumn.cell(rule)

	}

	handleOptionSelected = (option) => {
		this.setState({ optionValueSelected: option.value });
		if (option.value === "import-new-rules") {
			if (!option.isDisabled) this.setState({ bulkUploadModalVisible: true });
		} else {
			if (!option.isDisabled) this.setState({ objectLookupModalVisible: true });
		}
	}

	CustomOption = (props: { data: any; innerRef: any; innerProps: any; isDisabled: boolean }) => {
		const { data, innerRef, innerProps, isDisabled } = props;
		return (
			<div
				style={{ cursor: `${isDisabled ? 'not-allowed' : 'pointer'}` }}
				ref={innerRef}
				{...innerProps}
				className='custom-option-box'
			>
				<div style={{ color: `${isDisabled ? '#999' : '#1E55B1'}`, fontSize: 'large', }}>{data.isLoading ? data.loadingMessage : data.label}</div>
				<div style={{ color: '#999', fontSize: 'small', wordWrap: 'break-word', width: '180px' }}>{data.subtext}</div>
			</div>
		)
	}

	styles: StylesConfig<any, false> = {
		control: (css) => ({ ...css, width: 200, zIndex: 5 }),
	};

	render() {
		const tableHeaders = this.state.columns?.filter(column => column.header !== "Description").map((column) => (
			<Table.Head.Cell key={column.header}>
				{column.header}
			</Table.Head.Cell>
		));
		const tableRows = [];
		const defaultLimit = 10;
		const options = [
			{
				value: "import-new-rules",
				label: 'Import new rules',
				subtext: 'Add new rules at the same time with CSV file',
			},
			{
				value: "import-existing-rule",
				label: 'Import existing object',
				subtext: 'Add existing objects to delete or modify',
				isDisabled: this.props.loadingImplementedObjects || !(this.props.implementedObjects?.length > 0),
				isLoading: this.props.loadingImplementedObjects || !(this.props.implementedObjects?.length > 0),
				loadingMessage: (!(this.props.loadingImplementedObjects) && this.props.implementedObjects?.length == 0) ? 'No Objects Implemented' : 'Loading Existing Objects...'
			}
		];

		this.state.pageRows.forEach((rule, rowIndex) => {
			tableRows.push(
				<Table.Body.Row key={rowIndex}>
					<Table.Body.Cell>
						{this.props.rules.indexOf(rule) + 1}
					</Table.Body.Cell>
					{this.state.columns?.filter(column => column.header !== "Protocol" && column.header !== "Description").map((column, colIndex) => (
						<Table.Body.Cell
							key={`${rowIndex}-${colIndex}`}
							className="em-u-margin-right-auto"
							title={(column.cell(rule) || '-')}
						>
							{column.header === 'operation' ? (<POROperationBadge>{this.getOperationName(rule)}</POROperationBadge>)
								: (column.header === 'Type' ? (<PORTypeBadge >{column.cell(rule)}</PORTypeBadge>)
									: (column.cell(rule)?.length > (column.limit || defaultLimit) ?
										(`${column.cell(rule).trim().substring(0, (column.limit || defaultLimit))}...`)
										:
										(column.cell(rule) || '-')))}
						</Table.Body.Cell>
					))}
					<Table.Body.Cell>
						{!this.props.readonly ?
							<Button.Group>
								<Button
									style={{ zIndex: 0 }}
									variant="primary"
									size="small"
									onClick={() => this.setState({ ruleModalVisible: true, editingRule: rule })}
								>
									<PencilIcon size="small" />
								</Button>
								<Button
									style={{ zIndex: 0 }}
									variant="primary"
									size="small"
									onClick={() => this.handleDeleteOrRemoveRule(rule)}
								>
									<TrashcanIcon size="small" />
								</Button>
							</Button.Group>
							:
							<Button
								style={{ zIndex: 0 }}
								variant="primary"
								size="small"
								onClick={() => this.setState({ ruleModalVisible: true, editingRule: rule })}
							>
								See details
							</Button>
						}
					</Table.Body.Cell>
				</Table.Body.Row>
			);
		});

		return (
			<>
				<Field>
					<Field.Label>
						Objects
					</Field.Label>
					<Field.Body>
						<Table
							header={
								<Toolbar>
									{this.props.readonly &&
										<Toolbar.Item right>
										</Toolbar.Item>}
									{!this.props.readonly &&
										<Toolbar.Item right>
											<Field inline size="small">
												<Button.Group>
													<Button
														variant="primary"
														size="small"
														disabled={this.props.loadingImplementedObjects}
														onClick={() => this.setState({ ruleModalVisible: true })}
													>
														{(this.props.loadingImplementedObjects) ?
															<>
															<Loader className="icon-loader em-c-icon--small" />
															<span>Loading objects...</span>
															</>
															:
															<>
																<PlusFilledIcon size="small" />
																<span>Add New Object</span>
															</>}
													</Button>
													<Select
														placeholder='Import objects'
														value={this.state.optionValueSelected != null ? this.state.optionValueSelected : ''}
														onChange={(option) => this.handleOptionSelected(option)}
														components={{ Option: this.CustomOption }}
														options={options}
														styles={this.styles}
													/>
												</Button.Group>
											</Field>
										</Toolbar.Item>}
								</Toolbar>
							}
							footer={
								<Paginator
									data={this.props.rules}
									onPageChange={this.handlePageChange}
								/>
							}
						>
							<Table.Head>
								<Table.Head.Row>
									<Table.Head.Cell />
									{tableHeaders}
									<Table.Head.Cell>
									</Table.Head.Cell>
								</Table.Head.Row>
							</Table.Head>
							<Table.Body>
								{tableRows.length > 0 ?
									tableRows
									:
									<Table.Body.Row>
										<Table.Body.Cell
											colSpan={this.state.columns?.length + 2 || 2}
										>
											<i>No objects found.</i>
										</Table.Body.Cell>
									</Table.Body.Row>}
							</Table.Body>
						</Table>
					</Field.Body>
				</Field>
				{this.state.showTrashcanModal &&
					<TrashcanModal
						onClose={this.resetTrashcanModal}
						onRemove={this.handleRemoveRule}
						onDelete={this.handleDeleteRule}
						deleteNew={this.state.editingRule.operation.name==='Add'? true : false }
					/>
				}
				<ObjectModalOnPrem
					{...this.getRulesModalProps()}
					isReadOnly={this.props.readonly}
				/>
				{this.state.objectLookupModalVisible &&
					<ObjectLookupModal
						onSuccess={(objects) => {
							// Handle the selected objects
							this.props.onChange([...this.props.rules, ...objects]);
							this.props.setSelectedFromExisting([
								...this.props.selectedFromExisting, 
								...objects.map(obj => obj.name)
							]);
							this.setState({ objectLookupModalVisible: false });
						}}
						onCancel={() => {
							this.setState({ objectLookupModalVisible: false });
						}}
						visible={this.state.objectLookupModalVisible}
						alreadySelected={this.props.selectedFromExisting}
					/>}
				<BulkUploadModal
					visible={this.state.bulkUploadModalVisible}
					onSuccess={this.handleBulkUpload}
					onCancel={() => {
						this.setState({
							bulkUploadModalVisible: false,
							optionValueSelected: '',
						});
					}}
				/>
			</>
		);
	}
}